import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import { useEffect, useRef, useState } from 'react';
import { jsx } from '@emotion/core';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import AKTooltip from '@atlaskit/tooltip';
import { itemWrapperStyles, separatorStyles } from '../internal/styles';
import { name as packageName, version as packageVersion } from '../version.json';
import Button from './Button';
var analyticsAttributes = {
  componentName: 'breadcrumbsItem',
  packageName: packageName,
  packageVersion: packageVersion
};

var noop = function noop() {};

var BreadcrumbsItem = function BreadcrumbsItem(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasOverflow = _useState2[0],
      setOverflow = _useState2[1];

  var buttonRef = useRef(null);

  var _props$hasSeparator = props.hasSeparator,
      hasSeparator = _props$hasSeparator === void 0 ? false : _props$hasSeparator,
      truncationWidth = props.truncationWidth,
      analyticsContext = props.analyticsContext,
      _props$href = props.href,
      href = _props$href === void 0 ? '#' : _props$href,
      text = props.text,
      _props$onClick = props.onClick,
      onClickProvided = _props$onClick === void 0 ? noop : _props$onClick,
      restButtonProps = _objectWithoutProperties(props, ["hasSeparator", "truncationWidth", "analyticsContext", "href", "text", "onClick"]);

  var handleClicked = usePlatformLeafEventHandler(_objectSpread({
    fn: onClickProvided,
    action: 'clicked',
    analyticsData: analyticsContext
  }, analyticsAttributes)); // Recalculate hasOverflow on every render cycle
  // Overflow happen if length of button component is greater than truncation width
  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (truncationWidth && buttonRef.current) {
      var shouldOverflow = buttonRef.current.clientWidth >= truncationWidth;

      if (shouldOverflow !== hasOverflow) {
        setOverflow(shouldOverflow);
      }
    }
  });

  var buttonProps = _objectSpread(_objectSpread({}, restButtonProps), {}, {
    onClick: handleClicked,
    href: href,
    truncationWidth: truncationWidth,
    ref: buttonRef
  });

  return jsx("div", {
    css: itemWrapperStyles
  }, hasOverflow && truncationWidth ? jsx(AKTooltip, {
    content: text,
    position: "bottom"
  }, jsx(Button, buttonProps, text)) : jsx(Button, _extends({}, buttonProps, {
    hasOverflow: false
  }), text), hasSeparator ? jsx("div", {
    css: separatorStyles
  }, "/") : null);
};

export default BreadcrumbsItem;